import React from 'react'

const EnglishFlag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_11193_7438)'>
      <path
        d='M21.3628 4.85095H6.07031V20.3685H21.3628C22.7863 20.3685 23.9391 18.9877 23.9391 17.2871V7.9327C23.9391 6.2317 22.7863 4.8517 21.3628 4.8517'
        fill='#E6E7E8'
      />
      <path
        d='M7.90866 4.85097H2.63616C1.21491 4.85097 0.0610352 6.23097 0.0610352 7.93234V10.023V15.1953V17.2863C0.0610352 18.987 1.21379 20.3677 2.63804 20.3677H7.90679V4.85022'
        fill='#1B75BB'
      />
      <path
        d='M2.60874 4.85095C1.18486 4.85095 0.0317383 6.23095 0.0317383 7.93233V10.023V15.1961V17.2875C0.0317383 18.9885 1.18486 20.3688 2.60874 20.3688H7.17211V15.1953V10.0222V4.85095H2.60874Z'
        fill='#176496'
      />
      <path
        d='M21.3937 4.85095H16.125V20.3685H21.3937C22.8172 20.3685 23.97 18.9885 23.97 17.2871V15.1968V10.0237V7.93308C23.97 6.2317 22.8172 4.8517 21.3937 4.8517'
        fill='#EC1C24'
      />
      <g clipPath='url(#clip1_11193_7438)'>
        <path
          d='M21.1627 4.81873H2.33393C0.904059 4.81873 -0.252441 6.20435 -0.252441 7.9121V10.0117V15.2055V17.3051C-0.252441 19.0132 0.903684 20.3988 2.33393 20.3988H21.1664C22.5941 20.3988 23.7524 19.0132 23.7524 17.3051V15.2055V10.0117V7.9121C23.7524 6.20398 22.5952 4.81873 21.1653 4.81873'
          fill='#1B75BB'
        />
        <path
          d='M2.33442 4.82019C0.904172 4.82019 -0.251953 6.20244 -0.251953 7.90644V10.0012V15.1829V17.2777C-0.251953 18.9821 0.904172 20.3639 2.33442 20.3639H6.91617V15.1833V10.0008V4.82019H2.33442Z'
          fill='#176496'
        />
        <path
          d='M17.2566 10.8975L23.7505 10.8967V10.1782L18.3783 10.1782L23.5893 6.83319C23.398 6.19307 23.0335 5.62194 22.5396 5.29344L23.1321 6.21857L16.9319 10.1782H14.3331L22.2494 5.09807C21.9659 4.93194 21.6363 4.85094 21.3051 4.82019L14.2983 9.30294V4.82169H9.19639V9.23507L2.29977 4.82019C1.95027 4.82169 1.59814 4.89819 1.29064 5.05869L9.19564 10.1313V10.1782L6.64114 10.1782L0.364016 6.14953L0.899891 5.31253C0.459266 5.66015 0.109766 6.1784 -0.0743594 6.7664L5.24089 10.1789H-0.255859V10.9327L6.38164 10.9124L9.08652 12.6487L6.47127 14.3268L-0.255859 14.3249V15.0457L5.34927 15.0464L-0.0518594 18.5114C0.134516 19.0139 0.405266 19.4613 0.772391 19.7812L0.363266 19.144L6.74952 15.0457H9.19677V15.1188L1.31427 20.1524C1.56814 20.3047 1.88914 20.4029 2.20864 20.4029L2.45464 20.4022L9.19639 16.0735V20.4029H9.95389V15.5902L11.8113 14.3962L13.5434 15.5095V20.4033H14.3009V15.9929L21.1671 20.4022H21.1964C21.6213 20.4022 21.8703 20.3298 22.1838 20.1524L14.3013 15.0937V15.0449H16.858L23.1344 19.0724L22.6413 19.8472C23.026 19.5607 23.4164 19.0372 23.5698 18.4563L18.2526 15.0438L23.7524 15.0453V14.3302L17.1351 14.3245L14.5263 12.6517L17.2585 10.8989M15.8061 10.8989L13.795 12.1844L12.5046 11.3553L13.546 10.6859V10.8989H15.8073M13.096 12.6303L11.7779 13.4718L10.4924 12.6464L11.8068 11.803L13.096 12.6303ZM9.95689 4.87865H13.5464V9.7874L11.8045 10.9049L9.95652 9.71915L9.95655 4.8779M7.77818 10.9042L9.9558 10.897V10.6154L11.1048 11.3534L9.79043 12.1964L7.77818 10.9042ZM9.95655 14.6332V14.3242H7.87493L9.79043 13.0949L11.0741 13.9203L9.95655 14.6332ZM15.7398 14.3253L13.5461 14.3238V14.6062L12.5137 13.942L13.8288 13.0994L15.7398 14.3253Z'
          fill='white'
        />
        <path
          d='M23.7536 10.8123L15.9802 10.8134L23.2882 6.12219C23.0339 5.65569 22.6649 5.32907 22.2509 5.09619L13.5472 10.6773V4.82019H9.95693V10.6068L1.29068 5.05719C0.824934 5.29382 0.505434 5.63432 0.240684 6.07794L7.63756 10.8213L-0.252441 10.8479V14.4037L7.73468 14.4052L0.278559 19.1891C0.552309 19.6488 0.931059 19.9807 1.37356 20.1836L9.95656 14.6774V20.3999H13.5464V14.6114L22.1789 20.1498C22.4992 19.9901 22.9184 19.7201 23.2672 19.1377L15.8849 14.4074L23.7517 14.4119V10.8123H23.7506'
          fill='#EC1C24'
        />
        <path
          d='M6.82234 10.8225V14.4038H-0.249781L-0.253906 10.8461L6.82234 10.8225Z'
          fill='#C32129'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_11193_7438'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
      <clipPath id='clip1_11193_7438'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(-0.25)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default EnglishFlag
